import { render, staticRenderFns } from "./RelatedDeliverablesSocialMediaGrouped.vue?vue&type=template&id=1cfa7859&"
import script from "./RelatedDeliverablesSocialMediaGrouped.vue?vue&type=script&lang=js&"
export * from "./RelatedDeliverablesSocialMediaGrouped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports